import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaAccounts = {
  show: async(props) => {
    const { default: AccountShow } = await import('@/vue_widgets/lsa/accounts/show/index.vue')
    createVueApp(AccountShow, { props, sidebar })
  }
}
